<div class="MainContainer" style="padding-bottom: 2%;">

  <!-- E-Transport Step One: Main Configuration Form - ModernPopup Style -->
  <div class="ModernPopupOverlay" *ngIf="ShowETransportStepOne" (click)="ShowETransportStepOne = false; resetUITDropdowns();">
    <div class="ModernPopup medium" (click)="$event.stopPropagation()">
      <!-- Popup Header -->
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons" style="color: #4a7bb8;">local_shipping</i>
          <span>{{'GenerateUITTitle' | translate}} [{{UITShippingCompany?.Name}}]</span>
        </div>
        <button class="ModernPopupClose" (click)="ShowETransportStepOne = false; resetUITDropdowns();">
          <i class="material-icons">close</i>
        </button>
      </div>

      <!-- Popup Body -->
      <div class="ModernPopupBody">
        <!-- Row 1: Customs Station + Document Type -->
        <div class="ModernFormRow">
          <div class="ModernFormGroup">
            <label class="ModernFormLabel">{{ 'ETransportCustomsStation' | translate }}</label>
            <div class="CustomDropdownContainer" [class.dropdown-open]="showUITCustomsStationDropdown">
              <div class="SendEmailOverlayTransparent" *ngIf="showUITCustomsStationDropdown" (click)="showUITCustomsStationDropdown = false"></div>
              <div class="CustomDropdownBar" (click)="showUITCustomsStationDropdown = !showUITCustomsStationDropdown">
                <i class="material-icons dropdown-icon-left">location_on</i>
                <input type="text" class="CustomDropdownInput" [class.placeholder]="!ETransportCustomsStation"
                       [value]="ETransportCustomsStation?.Name || ''" placeholder="{{ 'Select' | translate }}" readonly />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showUITCustomsStationDropdown">
                <div class="CustomDropdownResult" *ngFor="let a of CustomsStations"
                     (click)="ETransportCustomsStation = a; showUITCustomsStationDropdown = false;">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="ETransportCustomsStation?.ID === a.ID ? '#4caf50' : '#ccc'">
                      {{ ETransportCustomsStation?.ID === a.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">{{a.Name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ModernFormGroup" style="flex: 2;">
            <label class="ModernFormLabel">{{ 'ETransportDocumentType' | translate }}</label>
            <div class="CustomDropdownContainer" [class.dropdown-open]="showUITDocumentTypeDropdown">
              <div class="SendEmailOverlayTransparent" *ngIf="showUITDocumentTypeDropdown" (click)="showUITDocumentTypeDropdown = false"></div>
              <div class="CustomDropdownBar" (click)="showUITDocumentTypeDropdown = !showUITDocumentTypeDropdown">
                <i class="material-icons dropdown-icon-left">description</i>
                <input type="text" class="CustomDropdownInput" [class.placeholder]="!ETransportDocumentType"
                       [value]="ETransportDocumentType?.Name || ''" placeholder="{{ 'Select' | translate }}" readonly />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showUITDocumentTypeDropdown">
                <div class="CustomDropdownResult" *ngFor="let a of ETransportDocumentTypes"
                     (click)="ETransportDocumentType = a; showUITDocumentTypeDropdown = false;">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="ETransportDocumentType?.ID === a.ID ? '#4caf50' : '#ccc'">
                      {{ ETransportDocumentType?.ID === a.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">{{a.Name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 2: Measuring Unit + Operation Reason -->
        <div class="ModernFormRow">
          <div class="ModernFormGroup">
            <label class="ModernFormLabel">{{ 'ETransportMeasuringUnit' | translate }}</label>
            <div class="CustomDropdownContainer" [class.dropdown-open]="showUITMeasuringUnitDropdown">
              <div class="SendEmailOverlayTransparent" *ngIf="showUITMeasuringUnitDropdown" (click)="showUITMeasuringUnitDropdown = false"></div>
              <div class="CustomDropdownBar" (click)="showUITMeasuringUnitDropdown = !showUITMeasuringUnitDropdown">
                <i class="material-icons dropdown-icon-left">straighten</i>
                <input type="text" class="CustomDropdownInput" [class.placeholder]="!ETransportMeasuringUnit"
                       [value]="ETransportMeasuringUnit?.Name || ''" placeholder="{{ 'Select' | translate }}" readonly />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showUITMeasuringUnitDropdown">
                <div class="CustomDropdownResult" *ngFor="let a of ETransportMeasuringUnits"
                     (click)="ETransportMeasuringUnit = a; showUITMeasuringUnitDropdown = false;">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="ETransportMeasuringUnit?.ID === a.ID ? '#4caf50' : '#ccc'">
                      {{ ETransportMeasuringUnit?.ID === a.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">{{a.Name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ModernFormGroup" style="flex: 2;">
            <label class="ModernFormLabel">{{ 'ETransportOperationReason' | translate }}</label>
            <div class="CustomDropdownContainer" [class.dropdown-open]="showUITOperationReasonDropdown">
              <div class="SendEmailOverlayTransparent" *ngIf="showUITOperationReasonDropdown" (click)="showUITOperationReasonDropdown = false"></div>
              <div class="CustomDropdownBar" (click)="showUITOperationReasonDropdown = !showUITOperationReasonDropdown">
                <i class="material-icons dropdown-icon-left">info</i>
                <input type="text" class="CustomDropdownInput" [class.placeholder]="!ETransportOperationReason"
                       [value]="ETransportOperationReason?.Name || ''" placeholder="{{ 'Select' | translate }}" readonly />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showUITOperationReasonDropdown">
                <div class="CustomDropdownResult" *ngFor="let a of ETransportOperationReasons"
                     (click)="ETransportOperationReason = a; showUITOperationReasonDropdown = false;">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="ETransportOperationReason?.ID === a.ID ? '#4caf50' : '#ccc'">
                      {{ ETransportOperationReason?.ID === a.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">{{a.Name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 3: Auto Plates Number + Operation Type -->
        <div class="ModernFormRow">
          <div class="ModernFormGroup">
            <label class="ModernFormLabel">{{ 'AutoPlatesNumber' | translate }}</label>
            <input type="text" class="ModernFormInput ModernFormInputOrange"
                   [(ngModel)]="UITAutoPlatesNumber"
                   placeholder="{{ 'AutoPlatesNumber' | translate }}"
                   autocomplete="off">
          </div>
          <div class="ModernFormGroup" style="flex: 2;">
            <label class="ModernFormLabel">{{ 'ETransportOperationType' | translate }}</label>
            <div class="CustomDropdownContainer" [class.dropdown-open]="showUITOperationTypeDropdown">
              <div class="SendEmailOverlayTransparent" *ngIf="showUITOperationTypeDropdown" (click)="showUITOperationTypeDropdown = false"></div>
              <div class="CustomDropdownBar" (click)="showUITOperationTypeDropdown = !showUITOperationTypeDropdown">
                <i class="material-icons dropdown-icon-left">category</i>
                <input type="text" class="CustomDropdownInput" [class.placeholder]="!ETransportOperationType"
                       [value]="ETransportOperationType ? '[' + ETransportOperationType.Name + '] ' + ETransportOperationType.Description : ''"
                       placeholder="{{ 'Select' | translate }}" readonly />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showUITOperationTypeDropdown">
                <div class="CustomDropdownResult" *ngFor="let a of ETransportOperationTypes"
                     (click)="ETransportOperationType = a; showUITOperationTypeDropdown = false;">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="ETransportOperationType?.ID === a.ID ? '#4caf50' : '#ccc'">
                      {{ ETransportOperationType?.ID === a.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">[{{a.Name}}] {{a.Description}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 4: Shipping Company -->
        <div class="ModernFormRow">
          <div class="ModernFormGroup" style="width: 100%;">
            <label class="ModernFormLabel">{{ 'ShippingCompany' | translate }}</label>
            <div class="CustomDropdownContainer" [class.dropdown-open]="showUITShippingCompanyDropdown">
              <div class="SendEmailOverlayTransparent" *ngIf="showUITShippingCompanyDropdown" (click)="showUITShippingCompanyDropdown = false"></div>
              <div class="CustomDropdownBar" (click)="showUITShippingCompanyDropdown = !showUITShippingCompanyDropdown">
                <i class="material-icons dropdown-icon-left">local_shipping</i>
                <input type="text" class="CustomDropdownInput" [class.placeholder]="!UITShippingCompany"
                       [value]="UITShippingCompany?.Name || ''" placeholder="{{ 'Select' | translate }}" readonly />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showUITShippingCompanyDropdown">
                <div class="CustomDropdownResult" *ngFor="let s of ShippingCompanies"
                     (click)="UITShippingCompany = s; showUITShippingCompanyDropdown = false;">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="UITShippingCompany?.ID === s.ID ? '#4caf50' : '#ccc'">
                      {{ UITShippingCompany?.ID === s.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">{{s.Name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 5: Customs Bureau (conditional for Import/Export) -->
        <div class="ModernFormRow" *ngIf="ETransportOperationType?.ID == 40 || ETransportOperationType?.ID == 50">
          <div class="ModernFormGroup" style="width: 100%;">
            <label class="ModernFormLabel">{{ 'ETransportCustomsBureau' | translate }}</label>
            <div class="CustomDropdownContainer" [class.dropdown-open]="showUITCustomsBureauDropdown">
              <div class="SendEmailOverlayTransparent" *ngIf="showUITCustomsBureauDropdown" (click)="showUITCustomsBureauDropdown = false"></div>
              <div class="CustomDropdownBar" (click)="showUITCustomsBureauDropdown = !showUITCustomsBureauDropdown">
                <i class="material-icons dropdown-icon-left">account_balance</i>
                <input type="text" class="CustomDropdownInput" [class.placeholder]="!ETransportCustomsBureau"
                       [value]="ETransportCustomsBureau?.Name || ''" placeholder="{{ 'Select' | translate }}" readonly />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showUITCustomsBureauDropdown">
                <div class="CustomDropdownResult" *ngFor="let s of ETransportCustomsBureaus"
                     (click)="ETransportCustomsBureau = s; showUITCustomsBureauDropdown = false;">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="ETransportCustomsBureau?.ID === s.ID ? '#4caf50' : '#ccc'">
                      {{ ETransportCustomsBureau?.ID === s.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">{{s.Name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 6: Total Shipment Value -->
        <div class="ModernFormRow">
          <div class="ModernFormGroup" style="width: 100%;">
            <label class="ModernFormLabel">{{ 'TotalShipmentValueNOVAT' | translate }}</label>
            <input type="text" class="ModernFormInput"
                   [(ngModel)]="TotalShipmentValueNOVATInput"
                   (change)="NormalizeShipmentValue(TotalShipmentValueNOVATInput)"
                   placeholder="{{ 'TotalShipmentValueNOVAT' | translate }}">
          </div>
        </div>

        <!-- Row 6b: Currency -->
        <div class="ModernFormRow">
          <div class="ModernFormGroup" style="width: 100%;">
            <label class="ModernFormLabel">{{ 'Currency' | translate }}</label>
            <div class="CustomDropdownContainer" [class.dropdown-open]="showUITCurrencyDropdown">
              <div class="SendEmailOverlayTransparent" *ngIf="showUITCurrencyDropdown" (click)="showUITCurrencyDropdown = false"></div>
              <div class="CustomDropdownBar" (click)="showUITCurrencyDropdown = !showUITCurrencyDropdown">
                <i class="material-icons dropdown-icon-left">payments</i>
                <input type="text" class="CustomDropdownInput" [class.placeholder]="!UITCurrency"
                       [value]="UITCurrency?.Name || ''" placeholder="{{ 'Select' | translate }}" readonly />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showUITCurrencyDropdown">
                <div class="CustomDropdownResult" *ngFor="let c of Currencies"
                     (click)="UITCurrency = c; showUITCurrencyDropdown = false;">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="UITCurrency?.ID === c.ID ? '#4caf50' : '#ccc'">
                      {{ UITCurrency?.ID === c.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">{{c.Name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 7: Shipment Weight -->
        <div class="ModernFormRow">
          <div class="ModernFormGroup" style="width: 100%;">
            <label class="ModernFormLabel">{{ 'ShipmentWeightKGs' | translate }}</label>
            <input type="text" class="ModernFormInput"
                   [(ngModel)]="ShipmentWeightKGsInput"
                   (change)="NormalizeShipmentWeight(ShipmentWeightKGsInput)"
                   placeholder="{{ 'ShipmentWeightKGs' | translate }}">
          </div>
        </div>

        <!-- Row 8: Document Number -->
        <div class="ModernFormRow">
          <div class="ModernFormGroup" style="width: 100%;">
            <label class="ModernFormLabel">{{ 'DocumentNumber' | translate }}</label>
            <input type="text" class="ModernFormInput ModernFormInputOrange"
                   [(ngModel)]="DocumentNumber"
                   placeholder="{{ 'DocumentNumber' | translate }}">
          </div>
        </div>
      </div>

      <!-- Popup Footer -->
      <div class="ModernPopupFooter">
        <button class="ModernButton outline" (click)="ShowETransportStepOne = false; resetUITDropdowns();">
          <i class="material-icons">close</i>
          {{ 'Cancel' | translate }}
        </button>
        <button class="ModernButton primary"
                [disabled]="!DocumentNumber || !ShipmentWeightKGs || !TotalShipmentValueNOVAT || DocumentBodyLoading"
                (click)="GenerateUIT();">
          <i class="material-icons" *ngIf="!DocumentBodyLoading">check</i>
          <div class="ModernButtonSpinner" *ngIf="DocumentBodyLoading"></div>
          {{ 'GenerateUIT' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- E-Transport Details View: UIT Result Display - ModernPopup Style -->
  <div class="ModernPopupOverlay" *ngIf="ShowETransportDetails" (click)="CloseUIT();">
    <div class="ModernPopup small" (click)="$event.stopPropagation()">
      <!-- Popup Header -->
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons" [style.color]="ETransportDetails?.Status?.ID == 1 ? '#4caf50' : '#f44336'">
            {{ ETransportDetails?.Status?.ID == 1 ? 'check_circle' : 'error' }}
          </i>
          <span>{{'ETransportResult' | translate}}</span>
        </div>
        <button class="ModernPopupClose" (click)="CloseUIT();">
          <i class="material-icons">close</i>
        </button>
      </div>

      <!-- Popup Body -->
      <div class="ModernPopupBody">
        <!-- Carrier Info -->
        <div class="UITCarrierBadge">
          <i class="material-icons">local_shipping</i>
          <span>{{UITShippingCompany?.Name}}</span>
        </div>

        <!-- Status Display -->
        <div class="UITResultCard" [class.success]="ETransportDetails?.Status?.ID == 1" [class.error]="ETransportDetails?.Status?.ID != 1">
          <div class="UITResultRow">
            <span class="UITResultLabel">{{'Status' | translate}}</span>
            <span class="UITResultValue status-badge" [class.success]="ETransportDetails?.Status?.ID == 1" [class.error]="ETransportDetails?.Status?.ID != 1">
              {{ETransportDetails?.Status?.Name}}
            </span>
          </div>
          <!-- Error Message (if any) -->
          <div class="UITResultRow error-message" *ngIf="ETransportDetails?.ETransportErrorMessage?.length > 0">
            <span class="UITResultLabel">{{'ErrorMessage' | translate}}</span>
            <span class="UITResultValue error-text">{{ETransportDetails.ETransportErrorMessage}}</span>
          </div>
          <!-- Upload ID -->
          <div class="UITResultRow">
            <span class="UITResultLabel">{{'UploadID' | translate}}</span>
            <span class="UITResultValue mono">{{ETransportDetails?.ETransportUploadID}}</span>
          </div>
        </div>

        <!-- UIT Number (highlighted card) -->
        <div class="UITHighlightCard">
          <div class="UITHighlightIcon">
            <i class="material-icons">qr_code_2</i>
          </div>
          <div class="UITHighlightContent">
            <span class="UITHighlightLabel">{{'UIT' | translate}}</span>
            <span class="UITHighlightValue">{{ETransportDetails?.UITUX || ETransportDetails?.ETransportUIT}}</span>
          </div>
          <button class="UITCopyButton" (click)="copyUITToClipboard(ETransportDetails?.UITUX || ETransportDetails?.ETransportUIT)" title="{{'CopyToClipboard' | translate}}">
            <i class="material-icons">content_copy</i>
          </button>
        </div>

        <!-- Shipment Details Card -->
        <div class="UITDetailsCard">
          <div class="UITDetailsRow">
            <span class="UITDetailsLabel"><i class="material-icons">business</i> {{'Partner' | translate}}</span>
            <span class="UITDetailsValue">{{UITPartner?.Name}}</span>
          </div>
          <div class="UITDetailsRow">
            <span class="UITDetailsLabel"><i class="material-icons">description</i> {{'DocumentNumber' | translate}}</span>
            <span class="UITDetailsValue">{{DocumentNumber}}</span>
          </div>
          <div class="UITDetailsRow">
            <span class="UITDetailsLabel"><i class="material-icons">attach_money</i> {{'ShipmentValue' | translate}}</span>
            <span class="UITDetailsValue">{{TotalShipmentValueNOVAT}} {{UITCurrency?.Name}}</span>
          </div>
          <div class="UITDetailsRow">
            <span class="UITDetailsLabel"><i class="material-icons">fitness_center</i> {{'Weight' | translate}}</span>
            <span class="UITDetailsValue">{{ShipmentWeightKGs}} KG</span>
          </div>
          <div class="UITDetailsRow">
            <span class="UITDetailsLabel"><i class="material-icons">person</i> {{'UserEmail' | translate}}</span>
            <span class="UITDetailsValue">{{parent?.User?.Email}}</span>
          </div>
        </div>
      </div>

      <!-- Popup Footer -->
      <div class="ModernPopupFooter">
        <button class="ModernButton primary" (click)="CloseUIT();">
          <i class="material-icons">done</i>
          {{ 'OK' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- E-Transport Step Zero: Partner Selection - ModernPopup Style -->
  <div class="ModernPopupOverlay" *ngIf="ShowETransportStepZero" (click)="ShowETransportStepZero = false; resetUITDropdowns();">
    <div class="ModernPopup small" (click)="$event.stopPropagation()">
      <!-- Popup Header -->
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons" style="color: #f60;">local_shipping</i>
          <span>{{'GenerateUITTitle' | translate}}</span>
        </div>
        <button class="ModernPopupClose" (click)="ShowETransportStepZero = false; resetUITDropdowns();">
          <i class="material-icons">close</i>
        </button>
      </div>

      <!-- Popup Body -->
      <div class="ModernPopupBody">
        <!-- Carrier Info Badge -->
        <div class="UITCarrierBadge" style="margin-bottom: 16px;">
          <i class="material-icons">local_shipping</i>
          <span>{{'Carrier' | translate}}: {{UITShippingCompany?.Name}}</span>
        </div>

        <!-- Partner Search Input - This is the PICKUP/MERCHANDISE partner -->
        <div class="ModernFormGroup" style="width: 100%; margin-bottom: 20px; position: relative; z-index: 20;">
          <label class="ModernFormLabel">
            <i class="material-icons" style="font-size: 14px; vertical-align: middle; margin-right: 4px;">place</i>
            {{ 'PickupPartner' | translate }}
          </label>
          <div class="ModernFormHint">{{'PickupPartnerHint' | translate}}</div>
          <div class="PartnerSearchContainer">
            <div class="PartnerSearchBar" [class.has-selection]="UITPartner">
              <i class="material-icons search-icon" *ngIf="!UITPartner">search</i>
              <i class="material-icons search-icon selected" *ngIf="UITPartner">check_circle</i>
              <input type="text" class="PartnerSearchInput"
                     [(ngModel)]="PartnersFilter.SearchTerm"
                     (ngModelChange)="partnerSearchTermUpdate.next($event)"
                     placeholder="{{ 'SearchPartnerByName' | translate }}"
                     [disabled]="UITPartner">
              <i class="material-icons clear-icon" *ngIf="PartnersFilter?.SearchTerm?.length > 0 || UITPartner" (click)="ResetPartnersSearch();">close</i>
            </div>
            <!-- Partner Search Results - Absolutely positioned -->
            <div class="PartnerSearchResults" *ngIf="Partners?.length > 0 && !UITPartner">
              <div class="PartnerSearchResult" *ngFor="let p of Partners" (click)="ChoosePartnerNewUIT(p);">
                <i class="material-icons">person</i>
                <div class="PartnerSearchResultInfo">
                  <span class="PartnerSearchResultName">{{p.Name}}</span>
                  <span class="PartnerSearchResultVat">{{'VAT' | translate}}: {{p.VAT}}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Selected Partner Display -->
          <div class="SelectedPartnerCard" *ngIf="UITPartner">
            <i class="material-icons">check_circle</i>
            <div class="SelectedPartnerInfo">
              <span class="SelectedPartnerName">{{UITPartner.Name}}</span>
              <span class="SelectedPartnerVat">{{'VAT' | translate}}: {{UITPartner.VAT}}</span>
            </div>
          </div>
        </div>

        <!-- General Document Type Dropdown -->
        <div class="ModernFormGroup" style="width: 100%; position: relative; z-index: 10;">
          <label class="ModernFormLabel">{{ 'GeneralDocType' | translate }}</label>
          <div class="CustomDropdownContainer">
            <div class="SendEmailOverlayTransparent" *ngIf="showUITGeneralDocTypeDropdown" (click)="showUITGeneralDocTypeDropdown = false"></div>
            <div class="CustomDropdownBar" (click)="showUITGeneralDocTypeDropdown = !showUITGeneralDocTypeDropdown">
              <i class="material-icons dropdown-icon-left">description</i>
              <input type="text" class="CustomDropdownInput" [class.placeholder]="!GeneralDocType"
                     [value]="GeneralDocType?.Name || ''" placeholder="{{ 'Select' | translate }}" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="CustomDropdownResults" *ngIf="showUITGeneralDocTypeDropdown">
              <div class="CustomDropdownResult" *ngFor="let s of GeneralDocTypes"
                   (click)="GeneralDocType = s; showUITGeneralDocTypeDropdown = false;">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons" [style.color]="GeneralDocType?.ID === s.ID ? '#4caf50' : '#ccc'">
                    {{ GeneralDocType?.ID === s.ID ? 'check_circle' : 'radio_button_unchecked' }}
                  </i>
                  <span class="CustomDropdownResultText">{{s.Name}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Popup Footer -->
      <div class="ModernPopupFooter">
        <button class="ModernButton outline" (click)="ShowETransportStepZero = false; resetUITDropdowns();">
          <i class="material-icons">close</i>
          {{ 'Cancel' | translate }}
        </button>
        <button class="ModernButton warning"
                [disabled]="!UITPartner || !GeneralDocType || DocumentBodyLoading"
                (click)="ShowETransportStepZero = false; PrepareETransportStep1(UITPartner);">
          <i class="material-icons" *ngIf="!DocumentBodyLoading">navigate_next</i>
          <div class="ModernButtonSpinner" *ngIf="DocumentBodyLoading"></div>
          {{ 'NextStep' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Main Tab Navigation: Shipping Companies vs UIT Numbers -->
  <div class="CarriersMainTabsWrapper">
    <div class="CarriersMainTab" [ngClass]="{'CarriersMainTabActive': selectedMainTab === 1}" (click)="onSelectMainTab(1)">
      <i class="material-icons">local_shipping</i>
      <span>{{'TransportCompanies' | translate}}</span>
    </div>
    <div class="CarriersMainTab" [ngClass]="{'CarriersMainTabActive': selectedMainTab === 2}" (click)="onSelectMainTab(2)">
      <i class="material-icons">qr_code_2</i>
      <span>{{'UITNumbers' | translate}}</span>
    </div>
  </div>

  <!-- Tab 1: Shipping Companies -->
  <div *ngIf="selectedMainTab === 1">
    <!-- MODERN CARRIERS PAGE -->
    <div class="ModernCarriersPage">

      <!-- Add New Carrier Popup (ModernPopup Style) -->
      <div class="ModernPopupOverlay" *ngIf="ShowOpenNewTransporterPopUp" (click)="ShowOpenNewTransporterPopUp = false; showNewCompanyCategoryDropdown = false;">
        <div class="ModernPopup small" (click)="$event.stopPropagation()">
          <div class="ModernPopupHeader">
            <div class="ModernPopupTitle">
              <i class="material-icons" style="color: #4caf50;">add_circle</i>
              <span>{{'AddNewShippingCompany' | translate}}</span>
            </div>
            <button class="ModernPopupClose" (click)="ShowOpenNewTransporterPopUp = false; showNewCompanyCategoryDropdown = false;">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="ModernPopupBody">
            <!-- Shipping Company Name Input -->
            <div class="ModernFormGroup" style="width: 100%; margin-bottom: 16px;">
              <label class="ModernFormLabel">{{ 'ShippingCompany' | translate }}</label>
              <input type="text" class="ModernFormInput"
                     [(ngModel)]="NewShippingCompany.Name"
                     placeholder="{{ 'ShippingCompany' | translate }}">
            </div>

            <!-- TransporterType Custom Dropdown -->
            <div class="ModernFormGroup" style="width: 100%; margin-bottom: 16px; position: relative; z-index: 20;">
              <label class="ModernFormLabel">{{ 'TransporterType' | translate }}</label>
              <div class="CustomDropdownContainer">
                <div class="SendEmailOverlayTransparent" *ngIf="showNewCompanyCategoryDropdown" (click)="showNewCompanyCategoryDropdown = false"></div>
                <div class="CustomDropdownBar" (click)="showNewCompanyCategoryDropdown = !showNewCompanyCategoryDropdown">
                  <i class="material-icons dropdown-icon-left">category</i>
                  <input type="text" class="CustomDropdownInput" [class.placeholder]="!NewShippingCompany.Category"
                         [value]="NewShippingCompany.Category?.Name || ''" placeholder="{{ 'SelectType' | translate }}" readonly />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults" *ngIf="showNewCompanyCategoryDropdown">
                  <div class="CustomDropdownResult" *ngFor="let c of MasterData.Categories"
                       (click)="NewShippingCompany.Category = c; showNewCompanyCategoryDropdown = false;">
                    <div class="CustomDropdownResultMain">
                      <i class="material-icons" [style.color]="NewShippingCompany.Category?.ID === c.ID ? '#4caf50' : '#ccc'">
                        {{ NewShippingCompany.Category?.ID === c.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <span class="CustomDropdownResultText">{{c.Name}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Associated Partner Search Input -->
            <div class="ModernFormGroup" style="width: 100%; margin-bottom: 16px; position: relative; z-index: 10;">
              <label class="ModernFormLabel">{{ 'AssociatedPartner' | translate }}</label>
              <div class="PartnerSearchContainer">
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">search</i>
                  <input type="text" class="PartnerSearchInput"
                         [(ngModel)]="PartnersFilter.SearchTerm"
                         (ngModelChange)="partnerSearchTermUpdate.next($event)"
                         placeholder="{{ 'AssociatedPartner' | translate }}">
                  <i class="material-icons clear-icon" *ngIf="PartnersFilter?.SearchTerm?.length > 0" (click)="ResetPartnersSearch();">close</i>
                </div>
                <div class="PartnerSearchResults" *ngIf="Partners?.length > 0 && !ShowETransportStepZero && !ShowETransportStepOne">
                  <div class="PartnerSearchResult" *ngFor="let p of Partners" (click)="ChoosePartnerNewTransporter(p);">
                    <i class="material-icons">person</i>
                    <div class="PartnerSearchResultInfo">
                      <span class="PartnerSearchResultName">{{p.Name}}</span>
                      <span class="PartnerSearchResultVat">{{'VAT' | translate}}: {{p.VAT}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Shipping Service Types Checkboxes -->
            <div class="ModernFormGroup" style="width: 100%;">
              <label class="ModernFormLabel">{{'ShippingServiceType' | translate}}</label>
              <div class="ModernCheckboxGrid">
                <label class="ModernCheckboxItem" *ngFor="let type of NewShippingCompany.ShippingServiceTypes" [class.selected]="type.IsSelected">
                  <input type="checkbox" [(ngModel)]="type.IsSelected">
                  <span class="ModernCheckboxBox">
                    <i class="material-icons">check</i>
                  </span>
                  <span class="ModernCheckboxLabel">{{type.Name}}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="ModernPopupFooter">
            <button class="ModernButton outline" (click)="ShowOpenNewTransporterPopUp = false; showNewCompanyCategoryDropdown = false;">
              <i class="material-icons">close</i>
              {{ 'Cancel' | translate }}
            </button>
            <button class="ModernButton primary" (click)="AddUpdateShippingCompanyWithDetails();">
              <i class="material-icons">add</i>
              {{'AddNewShippingCompany' | translate}}
            </button>
          </div>
        </div>
      </div>

      <!-- E-Factura Step Popup -->
      <div class="ModernPopupOverlay" *ngIf="EFacturaStepOne" (click)="EFacturaStepOne = false;">
        <div class="ModernPopup medium" (click)="$event.stopPropagation()">
          <div class="ModernPopupHeader">
            <div class="ModernPopupTitle">
              <i class="material-icons" style="color: #4a7bb8;">receipt_long</i>
              <span>{{'CheckTransportCosts' | translate}}</span>
            </div>
            <button class="ModernPopupClose" (click)="EFacturaStepOne = false;">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="ModernPopupBody">
            <div class="ModernFormHint" style="margin-bottom: 16px;">{{'ChooseEFacturaPeriod' | translate}}</div>

            <div class="ModernFormRow">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'VATNumber' | translate }}*</label>
                <input type="text" class="ModernFormInput" disabled [(ngModel)]="EFacturaFilter.VATNumber">
              </div>
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'Receptions.FromDate' | translate }}</label>
                <mat-form-field appearance="outline" style="width: 100%;">
                  <input matInput [matDatepicker]="dp2" [formControl]="EFacturaFromDate"
                         [min]="minDate" [max]="maxDate" [(ngModel)]="EFacturaFilter.FromDate"
                         (dateChange)="ClearPeriod()">
                  <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                  <mat-datepicker #dp2></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'Receptions.ToDate' | translate }}</label>
                <mat-form-field appearance="outline" style="width: 100%;">
                  <input matInput [matDatepicker]="dp3" [formControl]="EFacturaToDate"
                         [min]="minDate" [max]="maxDate" [(ngModel)]="EFacturaFilter.ToDate"
                         (dateChange)="ClearPeriod()">
                  <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                  <mat-datepicker #dp3></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="ModernPopupFooter">
            <button class="ModernButton outline" (click)="EFacturaStepOne = false;">
              <i class="material-icons">close</i>
              {{ 'Cancel' | translate }}
            </button>
            <button class="ModernButton primary" [disabled]="loadingEFacturaDocuments" (click)="AllocateTransportationCostsOnDocuments();">
              <i class="material-icons" *ngIf="!loadingEFacturaDocuments">navigate_next</i>
              <div class="ModernButtonSpinner" *ngIf="loadingEFacturaDocuments"></div>
              {{'CheckTransportCosts' | translate}}
            </button>
          </div>
        </div>
      </div>

      <!-- Modern Header Bar -->
      <div class="ModernHeaderBar">
        <div class="ModernHeaderLeft">
          <!-- Page Title -->
          <div class="ModernPageTitle">
            <i class="material-icons">local_shipping</i>
            <span>{{'ShippingCompanies' | translate}}</span>
          </div>

          <!-- Search Input -->
          <div class="ModernSearchInput">
            <i class="material-icons" *ngIf="!Filter.Product?.length">search</i>
            <input type="text" placeholder="{{ 'Search' | translate }}..."
                   [(ngModel)]="Filter.Product"
                   (keyup.enter)="GetShippingCompaniesFullData(); AddActiveFilter(Filter.Product, 'Product');">
            <i class="material-icons clear" *ngIf="Filter.Product?.length > 0"
               (click)="Filter.Product = ''; GetShippingCompaniesFullData();">close</i>
          </div>

          <!-- Filter Button -->
          <div style="position: relative;">
            <button class="ModernFilterButton" [class.active]="showFilter" (click)="showFilter = !showFilter">
              <i class="material-icons">filter_alt</i>
              <span>{{'Filter' | translate}}</span>
            </button>

            <!-- Filter Panel -->
            <div class="ModernFilterPanel" *ngIf="showFilter">
              <div class="ModernFilterPanelHeader">
                <span class="ModernFilterPanelTitle">{{'FilterOptions' | translate}}</span>
                <button class="ModernFilterPanelClose" (click)="showFilter = false;">
                  <i class="material-icons">close</i>
                </button>
              </div>
              <div class="ModernFilterPanelBody">
                <div class="ModernFormGroup" style="width: 100%;">
                  <label class="ModernFormLabel">{{ 'TransporterType' | translate }}</label>
                  <div class="CustomDropdownContainer">
                    <div class="SendEmailOverlayTransparent" *ngIf="showTransporterTypeDropdown" (click)="showTransporterTypeDropdown = false"></div>
                    <div class="CustomDropdownBar" (click)="showTransporterTypeDropdown = !showTransporterTypeDropdown">
                      <i class="material-icons dropdown-icon-left">category</i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!Filter.InvoiceDocType"
                             [value]="Filter.InvoiceDocType?.Name || ''" placeholder="{{ 'SelectType' | translate }}" readonly />
                      <i class="material-icons dropdown-icon">arrow_drop_down</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="showTransporterTypeDropdown">
                      <div class="CustomDropdownResult" *ngFor="let c of MasterData.Categories"
                           (click)="Filter.InvoiceDocType = c; AddActiveFilter(c.Name, 'InvoiceDocType'); showTransporterTypeDropdown = false;">
                        <div class="CustomDropdownResultMain">
                          <i class="material-icons" [style.color]="Filter.InvoiceDocType?.ID === c.ID ? '#4caf50' : '#ccc'">
                            {{ Filter.InvoiceDocType?.ID === c.ID ? 'check_circle' : 'radio_button_unchecked' }}
                          </i>
                          <span class="CustomDropdownResultText">{{c.Name}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ModernFilterPanelFooter">
                <button class="ModernButton primary" (click)="GetShippingCompaniesFullData(); showFilter = false;">
                  <i class="material-icons">search</i>
                  {{ 'Apply' | translate }}
                </button>
              </div>
            </div>
          </div>

          <!-- Active Filters -->
          <div class="ModernActiveFilters" *ngIf="activeFilters?.length > 0">
            <div class="ModernActiveFilter" *ngFor="let a of activeFilters" (click)="RemoveActiveFilter(a.ID, a.Type);">
              {{a.Name}}
              <i class="material-icons">close</i>
            </div>
          </div>
        </div>

        <div class="ModernHeaderRight">
          <!-- Pager Controls -->
          <div class="ModernPager">
            <button class="ModernPagerButton" [class.disabled]="Filter.Pager.PageIndex == 1"
                    (click)="Filter.Pager.PageIndex > 1 && GetShippingCompaniesFullData(Filter.Pager.PageIndex - 1)">
              <i class="material-icons">chevron_left</i>
            </button>
            <span class="ModernPagerInfo">
              {{ShippingCompanies?.length}} / {{Filter.Pager.TotalCount}}
            </span>
            <input type="number" class="ModernPageSizeInput" [(ngModel)]="Filter.Pager.PageSize"
                   (change)="GetShippingCompaniesFullData(1);" min="1" max="500">
            <span class="ModernPagerInfo">
              {{'Page' | translate}} {{Filter.Pager.PageIndex}}/{{Filter.Pager.Pages}}
            </span>
            <button class="ModernPagerButton" [class.disabled]="Filter.Pager.PageIndex == Filter.Pager.Pages"
                    (click)="Filter.Pager.PageIndex < Filter.Pager.Pages && GetShippingCompaniesFullData(Filter.Pager.PageIndex + 1)">
              <i class="material-icons">chevron_right</i>
            </button>
          </div>

          <!-- Add New Carrier Button -->
          <button class="ModernAddButton" (click)="OpenNewTransporterPopUp();">
            <i class="material-icons">add</i>
            <span>{{'AddNewShippingCompany' | translate}}</span>
          </button>
        </div>
      </div>

      <!-- Table Header -->
      <div class="ModernCarrierTableHeader">
        <div style="width: 5%;">#</div>
        <div style="width: 10%;">{{'Logo' | translate}}</div>
        <div style="width: 25%;">{{'ShippingCompany' | translate}}</div>
        <div style="width: 20%;">{{'TransporterType' | translate}}</div>
        <div style="width: 30%;"></div>
        <div style="width: 10%; text-align: center;">{{'Actions' | translate}}</div>
      </div>

      <!-- Carrier Cards Grid -->
      <div class="ModernCarrierGrid">
        <!-- Carrier Card -->
        <div class="ModernCarrierCard" *ngFor="let s of ShippingCompanies; let i = index;" [class.expanded]="s.IsSelected">
          <div class="ModernCarrierHeader" (click)="SelectShippingCompany(s);">
            <div class="ModernCarrierIndex">{{i + 1}}</div>
            <div class="ModernCarrierLogo">
              <img *ngIf="s.ImagePath?.length > 0" [src]="parent.BackendServiceUrl + s.ImagePath" alt="Logo" />
              <i class="material-icons" *ngIf="!s.ImagePath?.length" style="font-size: 28px; color: #ccc;">local_shipping</i>
            </div>
            <div class="ModernCarrierInfo">
              <div class="ModernCarrierName" *ngIf="!s.IsSelected">{{s.Name}}</div>
              <div class="ModernCarrierName" *ngIf="s.IsSelected" (click)="$event.stopPropagation();">
                <input type="text" class="ModernFormInput" [(ngModel)]="s.Name" style="width: 200px; height: 32px;">
              </div>
              <div class="ModernCarrierType" *ngIf="!s.IsSelected">{{s.Category?.Name}}</div>
              <div class="ModernCarrierType" *ngIf="s.IsSelected" (click)="$event.stopPropagation();">
                <div class="CustomDropdownContainer" style="width: 180px;">
                  <div class="CustomDropdownBar" style="height: 30px;" (click)="s.showCategoryDropdown = !s.showCategoryDropdown">
                    <span class="CustomDropdownValue" style="font-size: 11px;">{{s.Category?.Name || 'Select...'}}</span>
                    <i class="material-icons dropdown-icon" style="font-size: 16px;">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults" *ngIf="s.showCategoryDropdown" style="top: 32px;">
                    <div class="CustomDropdownResult" *ngFor="let c of MasterData.Categories" (click)="s.Category = c; s.showCategoryDropdown = false;">
                      {{c.Name}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ModernCarrierActions">
              <button class="ModernCarrierActionButton expand" (click)="$event.stopPropagation(); SelectShippingCompany(s);">
                <i class="material-icons">{{s.IsSelected ? 'expand_less' : 'expand_more'}}</i>
              </button>
            </div>
          </div>

          <!-- Expanded Body -->
          <div class="ModernCarrierBody" *ngIf="s.IsSelected">
            <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="bodyLoading" style="margin: 20px auto;"></mat-spinner>

            <div *ngIf="!bodyLoading">
              <!-- Support Contacts Section -->
              <div class="ModernCarrierSection">
                <div class="ModernCarrierSectionTitle">
                  <i class="material-icons">contact_mail</i>
                  {{'ShippingCompanySupportContacts' | translate}}
                </div>
                <div class="ModernSupportContactsGrid">
                  <div class="ModernSupportContact" *ngFor="let sc of s.SupportContacts" [class.expanded]="sc.IsSelected">
                    <div class="ModernSupportContactHeader" (click)="SelectEmailSupportCategory(sc, s);">
                      <span>{{sc.Category?.Name}}</span>
                      <i class="material-icons">{{sc.IsSelected ? 'expand_less' : 'expand_more'}}</i>
                    </div>
                    <div class="ModernSupportContactBody" *ngIf="sc.IsSelected">
                      <div class="ModernEmailChip" *ngFor="let e of sc.Emails">
                        <i class="material-icons">email</i>
                        <span>{{e.Email}}</span>
                        <i class="material-icons delete" (click)="DeleteShippingCompanySupportEmail(e.ID, sc, e);">close</i>
                      </div>
                      <div class="ModernAddEmailRow">
                        <input type="text" class="ModernFormInput" [(ngModel)]="NewEmailSupportCategory.Email" placeholder="Enter email...">
                        <button class="ModernButton primary small" (click)="AddEmailToSupportCategory(sc.Category.ID, s.ID);">
                          <i class="material-icons">add</i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Associated Partner Section -->
              <div class="ModernCarrierSection">
                <div class="ModernCarrierSectionTitle">
                  <i class="material-icons">business</i>
                  {{'AssociatedPartner' | translate}}
                  <span class="ModernPartnerBadge" *ngIf="s.Partner?.ID?.length > 0">
                    <i class="material-icons">verified</i>
                    {{s.Partner?.Name}} ({{'VAT' | translate}}: {{s.Partner.VAT}})
                  </span>
                </div>
                <div class="ModernFormRow">
                  <div class="ModernFormGroup" style="flex: 2; position: relative;">
                    <div class="PartnerSearchContainer">
                      <div class="PartnerSearchBar">
                        <i class="material-icons search-icon">search</i>
                        <input type="text" class="PartnerSearchInput" [(ngModel)]="PartnersFilter.SearchTerm"
                               (ngModelChange)="partnerSearchTermUpdate.next($event)"
                               placeholder="{{ 'AssociatedPartner' | translate }}">
                        <i class="material-icons clear-icon" *ngIf="PartnersFilter?.SearchTerm?.length > 0" (click)="ResetPartnersSearch();">close</i>
                      </div>
                      <div class="PartnerSearchResults" *ngIf="Partners?.length > 0 && !ShowETransportStepZero && !ShowETransportStepOne">
                        <div class="PartnerSearchResult" *ngFor="let p of Partners" (click)="ChoosePartner(p, s);">
                          <i class="material-icons">person</i>
                          <div class="PartnerSearchResultInfo">
                            <span class="PartnerSearchResultName">{{p.Name}}</span>
                            <span class="PartnerSearchResultVat">{{'VAT' | translate}}: {{p.VAT}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ModernFormGroup" style="flex: 1;">
                    <div class="ModernToggleContainer" matTooltip="{{'ROANCOMAuthorizedDescription' | translate}}" matTooltipClass='neutral-tool-tip'>
                      <label class="ModernToggle">
                        <input type="checkbox" [(ngModel)]="s.ROANCOMAuthorized">
                        <span class="ModernToggleSlider"></span>
                      </label>
                      <span class="ModernToggleLabel">{{'ROANCOMAuthorized' | translate}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- E-Transport UIT Section -->
              <div class="ModernCarrierSection">
                <div class="ModernCarrierSectionTitle">
                  <i class="material-icons">qr_code</i>
                  E-Transport UIT
                </div>
                <button class="ModernButton secondary" (click)="PrepareETransportStep0(s);" [disabled]="loadingUIT">
                  <i class="material-icons" *ngIf="!loadingUIT">play_arrow</i>
                  <div class="ModernButtonSpinner" *ngIf="loadingUIT"></div>
                  {{'GenerateUIT' | translate}}
                </button>
              </div>
            </div>

            <!-- Footer Actions -->
            <div class="ModernCarrierFooter" *ngIf="!bodyLoading">
              <button class="ModernButton primary" (click)="AddUpdateShippingCompany(s);" [disabled]="loadingShippingCompanyUpdate">
                <i class="material-icons" *ngIf="!loadingShippingCompanyUpdate">save</i>
                <div class="ModernButtonSpinner" *ngIf="loadingShippingCompanyUpdate"></div>
                {{'Update' | translate}}
              </button>
              <button class="ModernButton secondary" (click)="PrepareForTransportationCostsEFactura(s);" [disabled]="loadingShippingCompanyUpdate">
                <i class="material-icons" *ngIf="!loadingShippingCompanyUpdate">receipt_long</i>
                <div class="ModernButtonSpinner" *ngIf="loadingShippingCompanyUpdate"></div>
                {{'CheckInvoicesTransportationCosts' | translate}}
              </button>
            </div>
          </div>
        </div>

        <!-- Bottom Actions Card -->
        <div class="ModernCarrierCard" style="background: linear-gradient(135deg, #f0f4f8 0%, #e8f0f8 100%);">
          <div class="ModernCarrierFooter" style="padding: 16px 20px; justify-content: center;">
            <button class="ModernAddButton" (click)="OpenNewTransporterPopUp();">
              <i class="material-icons">add</i>
              {{'AddNewShippingCompany' | translate}}
            </button>
            <button class="ModernButton secondary" (click)="OpenAccountsPanel();">
              <i class="material-icons">account_balance</i>
              {{'ManageCarrierAccounts' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div> <!-- End ModernCarriersPage -->

    <!-- Shipping Company Accounts Panel -->
    <div class="overlay" *ngIf="ShowAccountsPanel == true || ShowAccountPopUp == true;"></div>

    <div class="AccountsPanel animated fadeInDown" *ngIf="ShowAccountsPanel == true;">
      <div class="AccountsPanelHeader">
        <p>{{'ShippingCompanyAccounts' | translate}}</p>
        <i class="material-icons" (click)="CloseAccountsPanel();">close</i>
      </div>

      <div class="AccountsPanelFilter">
        <!-- Shipping Company Filter Dropdown -->
        <div class="CustomDropdownContainer AccountsFilterField">
          <div class="SendEmailOverlayTransparent" *ngIf="showAccountsFilterShippingCompanyDropdown" (click)="showAccountsFilterShippingCompanyDropdown = false"></div>
          <div class="CustomDropdownBar" (click)="showAccountsFilterShippingCompanyDropdown = !showAccountsFilterShippingCompanyDropdown">
            <span class="dropdown-label">{{ 'ShippingCompany' | translate }}</span>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!AccountsFilter.ShippingCompanyID"
                   [value]="getFilterShippingCompanyName() || ('All' | translate)"
                   placeholder="{{ 'All' | translate }}" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showAccountsFilterShippingCompanyDropdown">
            <div class="CustomDropdownResult" (click)="AccountsFilter.ShippingCompanyID = null; showAccountsFilterShippingCompanyDropdown = false;">
              -- {{'All' | translate}} --
            </div>
            <div class="CustomDropdownResult" *ngFor="let s of this.MasterData?.ShippingCompanies"
                 (click)="AccountsFilter.ShippingCompanyID = s.ID; showAccountsFilterShippingCompanyDropdown = false;">
              {{s.Name}}
            </div>
          </div>
        </div>

        <!-- Direction Filter Dropdown -->
        <div class="CustomDropdownContainer AccountsFilterField">
          <div class="SendEmailOverlayTransparent" *ngIf="showAccountsFilterDirectionDropdown" (click)="showAccountsFilterDirectionDropdown = false"></div>
          <div class="CustomDropdownBar" (click)="showAccountsFilterDirectionDropdown = !showAccountsFilterDirectionDropdown">
            <span class="dropdown-label">{{ 'Direction' | translate }}</span>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!AccountsFilter.DirectionID"
                   [value]="getFilterDirectionName() || ('All' | translate)"
                   placeholder="{{ 'All' | translate }}" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showAccountsFilterDirectionDropdown">
            <div class="CustomDropdownResult" (click)="AccountsFilter.DirectionID = null; showAccountsFilterDirectionDropdown = false;">
              -- {{'All' | translate}} --
            </div>
            <div class="CustomDropdownResult" *ngFor="let d of this.Directions"
                 (click)="AccountsFilter.DirectionID = d.ID; showAccountsFilterDirectionDropdown = false;">
              {{d.Name}}
            </div>
          </div>
        </div>

        <!-- Company Filter Dropdown -->
        <div class="CustomDropdownContainer AccountsFilterField">
          <div class="SendEmailOverlayTransparent" *ngIf="showAccountsFilterCompanyDropdown" (click)="showAccountsFilterCompanyDropdown = false"></div>
          <div class="CustomDropdownBar" (click)="showAccountsFilterCompanyDropdown = !showAccountsFilterCompanyDropdown">
            <span class="dropdown-label">{{ 'Company' | translate }}</span>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!AccountsFilter.CompanyID"
                   [value]="getFilterCompanyName() || ('All' | translate)"
                   placeholder="{{ 'All' | translate }}" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showAccountsFilterCompanyDropdown">
            <div class="CustomDropdownResult" (click)="AccountsFilter.CompanyID = null; showAccountsFilterCompanyDropdown = false;">
              -- {{'All' | translate}} --
            </div>
            <div class="CustomDropdownResult" *ngFor="let c of this.Companies"
                 (click)="AccountsFilter.CompanyID = c.ID; showAccountsFilterCompanyDropdown = false;">
              {{c.Name}}
            </div>
          </div>
        </div>

        <!-- Partner Search Filter -->
        <div class="CustomDropdownContainer AccountsFilterField" style="position: relative;">
          <div class="CustomDropdownBar">
            <span class="dropdown-label">{{ 'Partner' | translate }}</span>
            <input type="text" class="CustomDropdownInput"
                   [placeholder]="SelectedFilterPartner?.Name || ('All' | translate)"
                   [(ngModel)]="FilterPartnerSearchTerm"
                   (ngModelChange)="filterPartnerSearchTermUpdate.next($event)"
                   [disabled]="SelectedFilterPartner">
            <i class="material-icons dropdown-clear" *ngIf="SelectedFilterPartner" (click)="ClearFilterPartner();">close</i>
            <i class="material-icons dropdown-icon" *ngIf="!SelectedFilterPartner">search</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="FilterPartners?.length > 0 && !SelectedFilterPartner">
            <div class="CustomDropdownResult" *ngFor="let p of FilterPartners" (click)="SelectFilterPartner(p);">
              {{p.Name}} <span style="font-size: 10px; color: #888;">{{p.VAT}}</span>
            </div>
          </div>
        </div>

        <!-- Account Number Input -->
        <input type="text" class="CustomTextInput AccountsFilterField"
               [(ngModel)]="AccountsFilter.AccountNumber"
               placeholder="{{ 'AccountNumber' | translate }}">

        <button class="GridCommandButton GridCommandButtonBlue" (click)="GetShippingCompanyAccountsFiltered();">
          <i class="material-icons">search</i>
        </button>
      </div>

      <div class="AccountsGrid">
        <div class="AccountsGridHeader">
          <div class="AccountsGridCell" style="width: 4%;">#</div>
          <div class="AccountsGridCell" style="width: 14%;">{{'ShippingCompany' | translate}}</div>
          <div class="AccountsGridCell" style="width: 15%;">{{'AccountNumber' | translate}}</div>
          <div class="AccountsGridCell" style="width: 12%;">{{'Partner' | translate}}</div>
          <div class="AccountsGridCell" style="width: 15%;">{{'Company' | translate}}</div>
          <div class="AccountsGridCell" style="width: 12%;">{{'Direction' | translate}}</div>
          <div class="AccountsGridCell" style="width: 12%;">{{'ServiceType' | translate}}</div>
          <div class="AccountsGridCell" style="width: 8%;">{{'Actions' | translate}}</div>
        </div>

        <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="loadingAccounts == true;"></mat-spinner>

        <div class="AccountsGridRow" *ngFor="let a of ShippingCompanyAccounts; let i = index;">
          <div class="AccountsGridCell" style="width: 4%;">{{i+1}}</div>
          <div class="AccountsGridCell" style="width: 14%;">{{a.ShippingCompanyName}}</div>
          <div class="AccountsGridCell" style="width: 15%;">{{a.AccountNumber}}</div>
          <div class="AccountsGridCell" style="width: 12%;">{{a.PartnerName}}</div>
          <div class="AccountsGridCell" style="width: 15%;">{{a.CompanyName}}</div>
          <div class="AccountsGridCell" style="width: 12%;">{{a.ShippingDirection?.Name}}</div>
          <div class="AccountsGridCell" style="width: 12%;">{{a.ShippingServiceType?.Name}}</div>
          <div class="AccountsGridCell AccountsGridActions" style="width: 8%;">
            <i class="material-icons" (click)="EditAccount(a);">edit</i>
            <i class="material-icons" style="color: red;" (click)="DeleteAccount(a);">delete</i>
          </div>
        </div>

        <div class="AccountsGridEmpty" *ngIf="ShippingCompanyAccounts?.length == 0 && loadingAccounts == false;">
          {{'NoRecordsFound' | translate}}
        </div>
      </div>

      <div class="AccountsPanelPager">
        <div class="TopPagingButton unSelectable" *ngIf="this.AccountsFilter.Pager.PageIndex != 1;" (click)="GetShippingCompanyAccountsFiltered(this.AccountsFilter.Pager.PageIndex - 1);">
          <i class="material-icons">chevron_left</i>
        </div>
        <div class="TopPagingButton unSelectable disabled" *ngIf="this.AccountsFilter.Pager.PageIndex == 1;">
          <i class="material-icons">chevron_left</i>
        </div>
        <span>{{this.AccountsFilter.Pager.PageIndex}} / {{this.AccountsFilter.Pager.Pages || 1}}</span>
        <div class="TopPagingButton unSelectable" *ngIf="this.AccountsFilter.Pager.PageIndex != this.AccountsFilter.Pager.Pages;" (click)="GetShippingCompanyAccountsFiltered(this.AccountsFilter.Pager.PageIndex + 1);">
          <i class="material-icons">chevron_right</i>
        </div>
        <div class="TopPagingButton unSelectable disabled" *ngIf="this.AccountsFilter.Pager.PageIndex == this.AccountsFilter.Pager.Pages;">
          <i class="material-icons">chevron_right</i>
        </div>
      </div>

      <div class="AccountsPanelCommands">
        <button class="GridCommandButton GridCommandButtonBlue" (click)="OpenNewAccountPopUp();">
          <i class="material-icons">add</i>
          <span>{{'AddNewAccount' | translate}}</span>
        </button>
      </div>
    </div>

    <!-- Account Add/Edit Popup -->
    <div class="AccountPopUp animated fadeInDown" *ngIf="ShowAccountPopUp == true;">
      <div class="AccountPopUpHeader">
        <p *ngIf="CurrentAccount?.ID == 0;">{{'AddNewAccount' | translate}}</p>
        <p *ngIf="CurrentAccount?.ID != 0;">{{'EditAccount' | translate}}</p>
        <i class="material-icons" (click)="CloseAccountPopUp();">close</i>
      </div>

      <div class="AccountPopUpBody">
        <!-- Shipping Company Dropdown (Required) -->
        <div class="CustomDropdownContainer" style="width: 100%;">
          <div class="SendEmailOverlayTransparent" *ngIf="showAccountShippingCompanyDropdown" (click)="showAccountShippingCompanyDropdown = false"></div>
          <div class="CustomDropdownBar" (click)="showAccountShippingCompanyDropdown = !showAccountShippingCompanyDropdown">
            <span class="dropdown-label">{{ 'ShippingCompany' | translate }}*</span>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentAccount?.ShippingCompany"
                   [value]="CurrentAccount?.ShippingCompany?.Name || ''"
                   placeholder="{{ 'SelectShippingCompany' | translate }}" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showAccountShippingCompanyDropdown">
            <div class="CustomDropdownResult" *ngFor="let s of this.MasterData?.ShippingCompanies"
                 (click)="CurrentAccount.ShippingCompany = s; showAccountShippingCompanyDropdown = false;">
              {{s.Name}}
            </div>
          </div>
        </div>

        <!-- Account Number Input -->
        <div class="CustomInputContainer">
          <span class="input-label">{{ 'AccountNumber' | translate }}</span>
          <input type="text" class="CustomTextInput"
                 [(ngModel)]="CurrentAccount.AccountNumber"
                 placeholder="{{ 'AccountNumber' | translate }}">
        </div>

        <!-- Partner Search Input -->
        <div class="CustomInputContainer">
          <span class="input-label">{{ 'Partner' | translate }}</span>
          <input type="text" class="CustomTextInput"
                 [placeholder]="CurrentAccount?.PartnerName || ('Partner' | translate)"
                 [(ngModel)]="this.PartnersFilter.SearchTerm"
                 (ngModelChange)="this.partnerSearchTermUpdate.next($event)"
                 [disabled]="CurrentAccount?.PartnerID">
          <i class="material-icons search-icon" *ngIf="!CurrentAccount?.PartnerID;">search</i>
          <i class="material-icons search-icon close" *ngIf="CurrentAccount?.PartnerID;" (click)="ClearAccountPartner();">close</i>
        </div>
        <div class="AssiciatedPartnerResultsContainer" *ngIf="this.Partners?.length > 0 && !CurrentAccount?.PartnerID && !ShowETransportStepZero && !ShowETransportStepOne;" style="max-height: 150px;overflow-y: auto;width: 100%;">
          <div class="PartnerResult" *ngFor="let p of this.Partners" (click)="SelectAccountPartner(p);">
            {{p.Name}} {{'VAT' | translate}}: {{p.VAT}}
          </div>
        </div>

        <!-- Direction Dropdown -->
        <div class="CustomDropdownContainer" style="width: 100%;">
          <div class="SendEmailOverlayTransparent" *ngIf="showAccountDirectionDropdown" (click)="showAccountDirectionDropdown = false"></div>
          <div class="CustomDropdownBar">
            <span class="dropdown-label">{{ 'Direction' | translate }}</span>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentAccount?.Direction"
                   [value]="CurrentAccount?.Direction?.Name || ''"
                   placeholder="{{ 'None' | translate }}" readonly
                   (click)="showAccountDirectionDropdown = !showAccountDirectionDropdown" />
            <i class="material-icons dropdown-clear" *ngIf="CurrentAccount?.Direction" (click)="CurrentAccount.Direction = null; $event.stopPropagation();">close</i>
            <i class="material-icons dropdown-icon" (click)="showAccountDirectionDropdown = !showAccountDirectionDropdown">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showAccountDirectionDropdown">
            <div class="CustomDropdownResult" *ngFor="let d of this.Directions"
                 (click)="CurrentAccount.Direction = d; showAccountDirectionDropdown = false;">
              {{d.Name}}
            </div>
          </div>
        </div>

        <!-- Service Type Dropdown -->
        <div class="CustomDropdownContainer" style="width: 100%;">
          <div class="SendEmailOverlayTransparent" *ngIf="showAccountServiceTypeDropdown" (click)="showAccountServiceTypeDropdown = false"></div>
          <div class="CustomDropdownBar">
            <span class="dropdown-label">{{ 'ServiceType' | translate }}</span>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentAccount?.ServiceType"
                   [value]="CurrentAccount?.ServiceType?.Name || ''"
                   placeholder="{{ 'None' | translate }}" readonly
                   (click)="showAccountServiceTypeDropdown = !showAccountServiceTypeDropdown" />
            <i class="material-icons dropdown-clear" *ngIf="CurrentAccount?.ServiceType" (click)="CurrentAccount.ServiceType = null; $event.stopPropagation();">close</i>
            <i class="material-icons dropdown-icon" (click)="showAccountServiceTypeDropdown = !showAccountServiceTypeDropdown">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showAccountServiceTypeDropdown">
            <div class="CustomDropdownResult" *ngFor="let t of this.ShippingServiceTypes"
                 (click)="CurrentAccount.ServiceType = t; showAccountServiceTypeDropdown = false;">
              {{t.Name}}
            </div>
          </div>
        </div>
      </div>

      <div class="AccountPopUpCommands">
        <button class="GridCommandButton GridCommandButtonGreen" (click)="SaveAccount();">
          <ng-container *ngIf="loadingAccounts != true;">
            <i class="material-icons">check</i>
            <span>{{'Save' | translate}}</span>
          </ng-container>
          <mat-spinner class="smallSpinner" [diameter]="20" *ngIf="loadingAccounts == true;"></mat-spinner>
        </button>
      </div>
    </div>
  </div> <!-- End Tab 1: Shipping Companies -->

  <!-- Tab 2: UIT Numbers -->
  <div *ngIf="selectedMainTab === 2">
    <!-- UIT Sub-tabs for Export/Import -->
    <div class="UITDirectionTabsWrapper">
      <div class="UITDirectionTab" [ngClass]="{'UITDirectionTabActive': selectedUITDirection === 1}" (click)="onSelectUITDirection(1)">
        <i class="material-icons">upload</i>
        <span>{{'Export' | translate}}</span>
      </div>
      <div class="UITDirectionTab" [ngClass]="{'UITDirectionTabActive': selectedUITDirection === -1}" (click)="onSelectUITDirection(-1)">
        <i class="material-icons">download</i>
        <span>{{'Import' | translate}}</span>
      </div>
    </div>

    <!-- UIT Filter Bar -->
    <div class="UITFilterBar">
      <div class="UITSearchInputWrapper">
        <i class="material-icons">search</i>
        <input type="text" placeholder="{{'SearchUITPlaceholder' | translate}}"
               [(ngModel)]="UITFilter.SearchTerm"
               (ngModelChange)="onUITSearchChange($event)">
        <i class="material-icons clear" *ngIf="UITFilter.SearchTerm?.length > 0"
           (click)="UITFilter.SearchTerm = ''; onUITFilterChange();">close</i>
      </div>

      <div class="UITFilterGroup">
        <mat-form-field appearance="outline" class="UITFilterField">
          <mat-label>{{'FromDate' | translate}}</mat-label>
          <input matInput [matDatepicker]="uitFromPicker" [(ngModel)]="UITFilter.FromDate" (dateChange)="onUITFilterChange()">
          <mat-datepicker-toggle matSuffix [for]="uitFromPicker"></mat-datepicker-toggle>
          <mat-datepicker #uitFromPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="UITFilterField">
          <mat-label>{{'ToDate' | translate}}</mat-label>
          <input matInput [matDatepicker]="uitToPicker" [(ngModel)]="UITFilter.ToDate" (dateChange)="onUITFilterChange()">
          <mat-datepicker-toggle matSuffix [for]="uitToPicker"></mat-datepicker-toggle>
          <mat-datepicker #uitToPicker></mat-datepicker>
        </mat-form-field>

        <select class="UITFilterSelect" [(ngModel)]="UITFilter.ExecutionStatusID" (change)="onUITFilterChange()">
          <option [ngValue]="null">{{'AllStatuses' | translate}}</option>
          <option [ngValue]="1">{{'Success' | translate}}</option>
          <option [ngValue]="0">{{'NotProcessed' | translate}}</option>
          <option [ngValue]="-1">{{'Error' | translate}}</option>
        </select>

        <select class="UITFilterSelect" [(ngModel)]="UITFilter.ShippingCompanyID" (change)="onUITFilterChange()">
          <option [ngValue]="null">{{'AllCompanies' | translate}}</option>
          <option *ngFor="let sc of MasterData?.ShippingCompanies" [ngValue]="sc.ID">{{sc.Name}}</option>
        </select>
      </div>

      <div class="UITPager">
        <button class="UITPagerButton" [disabled]="UITFilter.Pager?.PageIndex <= 1" (click)="GetUITNumbersFiltered(UITFilter.Pager.PageIndex - 1)">
          <i class="material-icons">chevron_left</i>
        </button>
        <span class="UITPagerInfo">{{UITNumbers?.length || 0}} / {{uitTotalCount}}</span>
        <span class="UITPagerInfo">{{'Page' | translate}} {{UITFilter.Pager?.PageIndex || 1}}/{{UITFilter.Pager?.Pages || 1}}</span>
        <button class="UITPagerButton" [disabled]="UITFilter.Pager?.PageIndex >= UITFilter.Pager?.Pages" (click)="GetUITNumbersFiltered(UITFilter.Pager.PageIndex + 1)">
          <i class="material-icons">chevron_right</i>
        </button>
      </div>
    </div>

    <!-- UIT Results Grid -->
    <div class="UITResultsGrid">
      <div class="UITResultsHeader">
        <div class="UITHeaderCell" style="width: 3%; display: flex; align-items: center; justify-content: center;">
          <label class="UITCheckboxWrapper">
            <input type="checkbox" [checked]="allUITSelected" (change)="toggleSelectAllUIT()" />
            <span class="UITCheckboxCustom"></span>
          </label>
        </div>
        <div class="UITHeaderCell" style="width: 5%;"></div>
        <div class="UITHeaderCell" style="width: 9%;">{{'UIT' | translate}}</div>
        <div class="UITHeaderCell" style="width: 7%;">{{'AutoPlatesNumber' | translate}}</div>
        <div class="UITHeaderCell" style="width: 7%;">{{'DocumentNumber' | translate}}</div>
        <div class="UITHeaderCell" style="width: 10%;">{{'Partner' | translate}}</div>
        <div class="UITHeaderCell" style="width: 9%;">{{'ShippingCompany' | translate}}</div>
        <div class="UITHeaderCell" style="width: 10%;">{{'ShipmentValue' | translate}}</div>
        <div class="UITHeaderCell" style="width: 7%;">{{'Weight' | translate}}</div>
        <div class="UITHeaderCell" style="width: 10%;">{{'UserEmail' | translate}}</div>
        <div class="UITHeaderCell" style="width: 7%;">{{'ExecutionStatus' | translate}}</div>
        <div class="UITHeaderCell" style="width: 10%;">{{'EventRegister' | translate}}</div>
      </div>

      <div class="UITResultsBody">
        <div class="UITLoadingSpinner" *ngIf="loadingUITNumbers">
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>

        <div class="UITNoResults" *ngIf="!loadingUITNumbers && (!UITNumbers || UITNumbers.length === 0)">
          <i class="material-icons">search_off</i>
          <span>{{'NoUITNumbersFound' | translate}}</span>
        </div>

        <div class="UITResultRow" *ngFor="let uit of UITNumbers">
          <div class="UITCell" style="width: 3%; display: flex; align-items: center; justify-content: center;">
            <label class="UITCheckboxWrapper">
              <input type="checkbox" [checked]="uit.isSelected" (change)="toggleUITSelection(uit)" />
              <span class="UITCheckboxCustom"></span>
            </label>
          </div>
          <div class="UITCell" style="width: 5%; display: flex; align-items: center; gap: 4px;">
            <button class="UITRowCopyButton" (click)="copyUITToClipboard(uit.UITUX || uit.UIT)" title="{{'CopyToClipboard' | translate}}">
              <i class="material-icons">content_copy</i>
            </button>
            <button class="UITRowRefreshButton" *ngIf="(uit.UITUX || uit.UIT)?.length > 0" (click)="CheckUITStatusBulk(uit)" [disabled]="uit.checkingStatus" title="{{'CheckUITStatus' | translate}}">
              <i class="material-icons" [ngClass]="{'spinning': uit.checkingStatus}">sync</i>
            </button>
          </div>
          <div class="UITCell" style="width: 9%;">
            <span class="UITCode">{{uit.UITUX || uit.UIT}}</span>
          </div>
          <div class="UITCell" style="width: 7%;">{{uit.AutoPlatesNumber}}</div>
          <div class="UITCell" style="width: 7%;">{{uit.DocumentNumber}}</div>
          <div class="UITCell" style="width: 10%;">{{uit.UITPartner?.Name}}</div>
          <div class="UITCell" style="width: 9%;">{{uit.ShippingCompany?.Name}}</div>
          <div class="UITCell" style="width: 10%;">{{uit.TotalShipmentValueNOVAT}} {{uit.Currency?.Name}}</div>
          <div class="UITCell" style="width: 7%;">{{uit.ShipmentWeightKGs}} KG</div>
          <div class="UITCell" style="width: 10%;">{{uit.UserEmail}}</div>
          <div class="UITCell" style="width: 7%;">
            <div class="UITStatusTooltipWrapper">
              <span class="UITStatusBadge" [ngClass]="{
                'status-success': uit.ExecutionStatus?.ID === 1,
                'status-pending': uit.ExecutionStatus?.ID === 0,
                'status-error': uit.ExecutionStatus?.ID === -1
              }">{{uit.ExecutionStatus?.Name}}</span>
              <div class="UITStatusTooltip" *ngIf="uit.InternalResponseMessage?.length > 0 && uit.ExecutionStatus?.ID !== 1">
                {{uit.InternalResponseMessage}}
              </div>
            </div>
          </div>
          <div class="UITCell" style="width: 10%;">{{uit.EventRegister | date:'yyyy-MM-dd HH:mm'}}</div>
        </div>
      </div>
    </div>
  </div> <!-- End Tab 2: UIT Numbers -->

</div>
